module.exports = __webpack_public_path__ + "static/media/Sec-1_HomePageWeb_EN.604d1fd8.png";